// extracted by mini-css-extract-plugin
export default {"mCard":"bB-z","image":"cB-z","imageNoBackground":"dB-z","imageHasCategory":"eB-z","fullWidth":"fB-z"};